/*
 * Yup string validators for Alphanumeric and Alphaonly strings.
 * Have parameters to define the max length and error messages.
 */
import * as yup from 'yup'
import { alphaRegex } from '../strings/regex'

const alphaStringYup = (
  errorMessage,
  excludeEmptyString,
  maxLength,
  maxLengthErrorMessage
) =>
  yup
    .string()
    .matches(alphaRegex, {
      message: errorMessage,
      excludeEmptyString: excludeEmptyString
    })
    .max(maxLength, maxLengthErrorMessage)

export const alphaStringYupOptional = (
  errorMessage,
  maxLength,
  maxLengthErrorMessage
) => alphaStringYup(errorMessage, true, maxLength, maxLengthErrorMessage)

export const alphaStringYupRequired = (
  errorMessage,
  maxLength,
  maxLengthErrorMessage
) =>
  alphaStringYup(
    errorMessage,
    false,
    maxLength,
    maxLengthErrorMessage
  ).required(errorMessage)

const stringYup = (maxLength, maxLengthErrorMessage) =>
  yup.string().max(maxLength, maxLengthErrorMessage)

export const stringYupOptional = (maxLength, maxLengthErrorMessage) =>
  stringYup(maxLength, maxLengthErrorMessage)

export const stringYupRequired = (
  errorMessage,
  maxLength,
  maxLengthErrorMessage
) => stringYup(maxLength, maxLengthErrorMessage).required(errorMessage)
